import React, { memo } from "react";

import { Container } from "@mui/material";
// import video from "./assets/videos/home-banner.mp4";
import "./HomeBanner.css";

import { FullPaddingWrapper } from "../../../../Components/FullPaddingWrapper/FullPaddingWrapper";
import VideoBanner from "./VideoBanner";

const HomeBanner = memo(() => {
  return (
    <Container maxWidth={"xl"} disableGutters>
      <FullPaddingWrapper>
        <VideoBanner />
      </FullPaddingWrapper>
    </Container>
  );
});

export default HomeBanner;
